import { cloneDeep } from 'lodash';
import reportList from './reports/reportList';

export function getReports(search) {
  const reports = cloneDeep(reportList);

  function filterReports(report, index, reportReference) {
    if (report.children) {
      report.children = report.children.filter(filterReports);

      if (reportReference) {
        reportReference[index] = cloneDeep(report);
      }
    }

    return !!report.children || new RegExp(search, 'gmiu').test(report.name);
  }

  const filteredReports = [];
  reports.forEach((report, index) => filterReports(report, index, filteredReports));

  return filteredReports.filter(nonEmptyParents);
}

export function nonEmptyParents(report) {
  if (report.children) {
    report.children = report.children.filter(nonEmptyParents);

    return report.children.length > 0;
  }

  return true;
}
